export const PACKAGE_NAME = 'jira-navigation-apps-sidebar-nav4-projects-customise-order';
export const TEAM_NAME = 'jira-cosmos';
